import { render, staticRenderFns } from "./BotoneraAccionesImpago.vue?vue&type=template&id=826f5faa&"
import script from "./BotoneraAccionesImpago.vue?vue&type=script&lang=js&"
export * from "./BotoneraAccionesImpago.vue?vue&type=script&lang=js&"
import style0 from "./BotoneraAccionesImpago.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports